// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_u-k","cls2":"ArticlesFilters-cls2_BlB ArticlesFilters-cls1_u-k"};